import { z } from 'zod/mini'

import { eventValue, itemObject } from './fields'
import { gtmMetadataShape } from './gtm-metadata'
import { itemShape } from './item'
import { nonEmptyString } from './non-empty-string'

export const viewItemSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_item'),
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    value: eventValue(),
    // trackViewItem always sends the viewed product only
    items: z
      .array(
        itemObject({
          ...itemShape,
          item_is_trade_in_eligible: z.boolean(),
        }),
      )
      .check(z.minLength(1), z.maxLength(1)),
  }),
})
